module.exports = "/assets/dist/images/how-it-works-drivetrain.svg?91930d8b7a8f9cc5cf847c37020af5cd";